export enum ErrorCause {
  AuthenticationError = 'authentication error',
  CognitoError = 'cognito error',
  RegistrationError = 'registration error',
  TokenError = 'token error',
  WindowError = 'window error',
}
